/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BinderClaimFinancialSummaryResponseDto,
  BinderClaimPaginationResponseDto,
  BinderClaimResponseDto,
  CreateBinderClaimPayloadDto,
  ErrorResponse,
  FilterBinderClaimsQueryDto,
  UpdateBinderClaimPayloadDto,
} from '../models/index';
import {
    BinderClaimFinancialSummaryResponseDtoFromJSON,
    BinderClaimFinancialSummaryResponseDtoToJSON,
    BinderClaimPaginationResponseDtoFromJSON,
    BinderClaimPaginationResponseDtoToJSON,
    BinderClaimResponseDtoFromJSON,
    BinderClaimResponseDtoToJSON,
    CreateBinderClaimPayloadDtoFromJSON,
    CreateBinderClaimPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterBinderClaimsQueryDtoFromJSON,
    FilterBinderClaimsQueryDtoToJSON,
    UpdateBinderClaimPayloadDtoFromJSON,
    UpdateBinderClaimPayloadDtoToJSON,
} from '../models/index';

export interface FilterBinderClaimsRequest {
    filterBinderClaimsQueryDto: FilterBinderClaimsQueryDto;
    field?: FilterBinderClaimsFieldEnum;
    order?: FilterBinderClaimsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface GetBinderClaimByIdRequest {
    claimNo: string;
    includeInsured?: boolean;
    includeReinsured?: boolean;
    includeBroker?: boolean;
    includeClaimHandlerUser?: boolean;
}

export interface GetBinderClaimFinancialSummaryRequest {
    claimId: string;
    contractId: string;
}

export interface RegisterBinderClaimRequest {
    createBinderClaimPayloadDto: CreateBinderClaimPayloadDto;
}

export interface UpdateBinderClaimRequest {
    claimId: string;
    contractId: string;
    updateBinderClaimPayloadDto: UpdateBinderClaimPayloadDto;
}

/**
 * 
 */
export class BinderClaimApi extends runtime.BaseAPI {

    /**
     * Filter binder claims
     */
    async filterBinderClaimsRaw(requestParameters: FilterBinderClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimPaginationResponseDto>> {
        if (requestParameters['filterBinderClaimsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterBinderClaimsQueryDto',
                'Required parameter "filterBinderClaimsQueryDto" was null or undefined when calling filterBinderClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterBinderClaimsQueryDtoToJSON(requestParameters['filterBinderClaimsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter binder claims
     */
    async filterBinderClaims(requestParameters: FilterBinderClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimPaginationResponseDto> {
        const response = await this.filterBinderClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get binder claim by id
     */
    async getBinderClaimByIdRaw(requestParameters: GetBinderClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimResponseDto>> {
        if (requestParameters['claimNo'] == null) {
            throw new runtime.RequiredError(
                'claimNo',
                'Required parameter "claimNo" was null or undefined when calling getBinderClaimById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeInsured'] != null) {
            queryParameters['includeInsured'] = requestParameters['includeInsured'];
        }

        if (requestParameters['includeReinsured'] != null) {
            queryParameters['includeReinsured'] = requestParameters['includeReinsured'];
        }

        if (requestParameters['includeBroker'] != null) {
            queryParameters['includeBroker'] = requestParameters['includeBroker'];
        }

        if (requestParameters['includeClaimHandlerUser'] != null) {
            queryParameters['includeClaimHandlerUser'] = requestParameters['includeClaimHandlerUser'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim/{claimNo}`.replace(`{${"claimNo"}}`, encodeURIComponent(String(requestParameters['claimNo']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get binder claim by id
     */
    async getBinderClaimById(requestParameters: GetBinderClaimByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimResponseDto> {
        const response = await this.getBinderClaimByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get binder claim financial summary
     */
    async getBinderClaimFinancialSummaryRaw(requestParameters: GetBinderClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimFinancialSummaryResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getBinderClaimFinancialSummary().'
            );
        }

        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getBinderClaimFinancialSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim/{claimId}/{contractId}/financial-summary`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimFinancialSummaryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get binder claim financial summary
     */
    async getBinderClaimFinancialSummary(requestParameters: GetBinderClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimFinancialSummaryResponseDto> {
        const response = await this.getBinderClaimFinancialSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register binder claim
     */
    async registerBinderClaimRaw(requestParameters: RegisterBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimResponseDto>> {
        if (requestParameters['createBinderClaimPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createBinderClaimPayloadDto',
                'Required parameter "createBinderClaimPayloadDto" was null or undefined when calling registerBinderClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBinderClaimPayloadDtoToJSON(requestParameters['createBinderClaimPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Register binder claim
     */
    async registerBinderClaim(requestParameters: RegisterBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimResponseDto> {
        const response = await this.registerBinderClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update binder claim
     */
    async updateBinderClaimRaw(requestParameters: UpdateBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateBinderClaim().'
            );
        }

        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling updateBinderClaim().'
            );
        }

        if (requestParameters['updateBinderClaimPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateBinderClaimPayloadDto',
                'Required parameter "updateBinderClaimPayloadDto" was null or undefined when calling updateBinderClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim/{claimId}/{contractId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBinderClaimPayloadDtoToJSON(requestParameters['updateBinderClaimPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update binder claim
     */
    async updateBinderClaim(requestParameters: UpdateBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimResponseDto> {
        const response = await this.updateBinderClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterBinderClaimsFieldEnum = {
    Insured: 'insured',
    Status: 'status',
    LineOfBusiness: 'lineOfBusiness',
    DateReported: 'dateReported',
    ClaimsHandler: 'claimsHandler'
} as const;
export type FilterBinderClaimsFieldEnum = typeof FilterBinderClaimsFieldEnum[keyof typeof FilterBinderClaimsFieldEnum];
/**
 * @export
 */
export const FilterBinderClaimsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterBinderClaimsOrderEnum = typeof FilterBinderClaimsOrderEnum[keyof typeof FilterBinderClaimsOrderEnum];
